import AssessmentModal from "components/Assessment/AssessmentModal";
import PrimeInvestmentPreferenceContainer from "containers/jarivsPrime/PrimeInvestmentPreference";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";

const PrimeInvestmentPreference = (props) => {
  const [openModal, setOpenModal] = useState(false);

  const getCurrentStage = useSelector(
    (state) => state.jarvisPrime.primeOnboarding.currentStagePrime
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (getCurrentStage >= 1) {
      setOpenModal(true);
    }
  }, []);

  const handleClose = () => setOpenModal(false);

  const handleConfirm = () => {
    setOpenModal(false);
    dispatch(
      jarvisPrimeOnboardingActions.updatePrimeOnboardingData({
        currentStagePrime: 0,
      })
    );
    window.location.reload();
  };

  return (
    <>
      <PrimeInvestmentPreferenceContainer />
      <AssessmentModal
        open={openModal}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};

export default PrimeInvestmentPreference;
